import { makeAutoObservable, toJS, runInAction, makeObservable, observable, computed, action } from "mobx"
// import { download } from '../../hooks/download'
import axios from 'axios'
import applyCaseMiddleware from 'axios-case-converter';

import { setConfig, loadJson, resetEditor } from '../editor/editorSlice'
import { addToMyLoop, deleteLoop, fetchPack } from './LoopApi'
// import userStore from "../common/userStore";
import download from "../account/download";
import dayjs from "dayjs";
import userStore from "../common/userStore";


const client = applyCaseMiddleware(axios.create());

class LoopRowModel {

  parent = null

  loop = null

  wave = null //

  playing = false

  json = null

  open = false

  loading = false

  posting = false

  pending = false

  deleted = false

  pack = null

  packConfig = null

  downloading = false

  mock = false

  dispatch = null

  dom = null

  autoPlay = false

  constructor({parent, loop, mock = false}) {
    makeAutoObservable(this, {
      wave: false,
      dispatch: false,
      dom: false
    })
    this.parent = parent
    this.loop = loop
    this.mock = mock
  }

  get id() {
    return this.loop.id
  }

  get config() {
    return this.packConfig || this.parent.packConfig
  }

  get midi() {
    return this.parent.pack?.midi || this.loop.midi
  }

  get free() {
    return this.parent.pack?.free
  }

  get loopState() {
    return this.parent.loopState
  }

  get packId() {
    return this.loop.packId || this.parent.packId
  }

  get parentId() {
    return this.loop.parentId
  }

  get name() {
    return this.loop.name
  }

  get bars() {
    return this.json?.bars
  }

  get key() {
    return this.loop.key
  }

  get bpm() {
    return this.loop.bpm
  }

  get mode() {
    return this.loop.mode
  }

  get instrument() {
    return this.loop.instrument
  }

  get modifyTime() {
    return dayjs(this.loop.modifyTime).format('MM/DD/YYYY')
    // return this.loop.modifyTime.split('T')[0]
  }

  get url() {
    return this.loop.url
  }

  get alreadyAdd() {
    return this.loop.alreadyAdd
  }

  get active() {
    return this.parent.playingLoop === this
  }

  get canEdit() {
    return !this.playing
  }

  get isMy() {
    return this.parent.loopState === 'myloops'
  }

  get hasToMyloops() {
    return this.loop.alreadyAdd === 1
  }

  get packCover() {
    return this.pack?.cover || this.loop.cover
  }

  get thumbnail() {
    return this.loop.thumbnail || this.loop.cover 



  }

  get preview() {
    //console.log('preview', this.parent.pack?.preview, this.loop.preview)
    return this.parent.pack?.preview || this.loop.preview
  }

  get downloaded() {
    return this.loop.alreadyDownload === 1
  }

  get packBannerImage() {
    return this.parent.pack?.banner || this.loop.banner
  }

  get packCoverImage() {
    return this.parent.pack?.cover || this.loop.cover
  }

  toDownload = async(midi = 0) => {
    try {
      if (userStore.isAnonymous) {
        userStore.setOpenSignup(true)
        return false;
      }
      this.downloading = true
      const ok = await download(this.id, this.loop, midi)
      if (this.loopState !== 'myloops') {
        await this.addToMyLoop()
      }
      // userStore.loadCredit()
      if (ok) {
        runInAction(() => {
          this.loop.alreadyDownload = 1
        })
        return true
      }
    } finally {
      runInAction(() => {
        this.downloading = false
      })
    }
    return false
  }

  stopPlay = () => {
    this.wave.stop()
    this.playing = false
  }

  togglePlaying = () => {
    if (this.playing) {
      this.wave.stop()
      this.playing = false
    }
    else {
      this.pending = true
      this.wave.once('play', action(() => {
        this.pending = false
        if (!this.playing) {
          this.wave.stop()
        }
      }))
      this.wave.once('finish', action(() => {
        this.wave.stop()
        this.playing = false
      }))
      this.playing = true
      this.wave.play()
    }
    if (!this.active) {
      this.parent.toPlaying(this)
    }
    return this.playing
  }

  onPlaying = () => {
    if (this.active) {
      return;
    }
    if (this.playing) {
      this.wave.stop()
      this.playing = false
    }
  }

  setJson = (data) => {
    this.json = data
  }

  loadJson = async () => {
    try {
      this.setLoading(true)
      const rsp = await client(this.loop.json);
      if (rsp.status === 200 && rsp.data && rsp.data.thumbnail) {
        this.setJson(rsp.data || {})
      }
      // if (!this.parent.packId) {
      //   await this.loadPack()
      // }
    } finally {
      this.setLoading(false)
    }
  }

  loadPack = async() => {
    const pack = await fetchPack({id: this.loop.packId})
    runInAction(() => {
      this.pack = pack[0];
    })
  }

  setLoading = (loading) => {
    this.loading = loading
  }

  toOpen = async() => {
    if (!this.config) {
      const packConfig = await client(this.loop.config);
      runInAction(() =>  this.packConfig = packConfig.data)
    }
    this.dispatch(resetEditor())
    this.dispatch(loadJson(toJS(this.json)))
    this.dispatch(setConfig(toJS(this.config)))
    runInAction(() => this.open = true)
  }

  setDispatch = (dispatch) => {
    this.dispatch = dispatch
  }

  toClose = () => {
    this.open = false
  }

  setWave = (wave) => {
    this.wave = wave
    if (this.autoPlay && wave) {
      this.togglePlaying()
      this.autoPlay = false
    }
  }

  setPosting = (posting) => {
    this.posting = posting
  }

  addToMyLoop = async () => {
    try {
      if (userStore.isAnonymous) {
        userStore.setOpenSignup(true)
        return false;
      }
      if (this.loop.alreadyAdd == 1) {
        return true;
      }
      this.posting = true
      this.loop.alreadyAdd = 1
      await addToMyLoop({
        loopId: this.loop.id, 
        name: this.loop.name
      })
      runInAction(() => {
        this.loop.alreadyAdd = 1
      })
      return true
    } finally {
      runInAction(() => {
        this.posting = false
      })
    }
  }

  deleteMyLoop = async () => {
    if (!this.deleted) {
      return
    }
    try {
      this.posting = true
      await deleteLoop({
        loopId: this.loop.id
      })
      if (this.parent) {
        this.parent.removeLoop(this)
      }
    } finally {
      runInAction(() => {
        this.posting = false
      })
    }
  }

  removeMyLoop = () => {
    this.deleted = true
  }

  undoRemove = () => {
    this.deleted = false
  }

  setDom = (dom) => {
    this.dom = dom
  }

  toView = () => {
    if (this.dom == null) {
      return;
    }
    const rect = this.dom.getBoundingClientRect();
    if (rect.top < 0) {
      console.log(rect, window.pageYOffset, window.scrollY)
      window.scrollBy(0, rect.top)
    }
    else if (rect.top + rect.height > window.innerHeight) {
      window.scrollBy(0, rect.top + rect.height - window.innerHeight)
    }
  }

  setAutoPlay = (autoPlay) => {
    this.autoPlay = autoPlay
  }

}

class AbsLoopsModel {

  pageSize = 30

  loopState = null

  page = 1

  loops = Array.from({length:30}, (v,k) => new LoopRowModel({parent: this, loop:{id:k}, mock:true}));

  loading = true

  playingLoop = null

  count = 0

  packId = null

  packConfig = null

  bpm = {minBpm: 40, maxBpm: 200, doubled: 1}

  mode = 'all'

  instrument = 'all'

  search = ''

  autoPlayType = ''

  editorOpen = false

  constructor() {
    makeObservable(this, {
      pageSize: observable,
      loopState: observable,
      page: observable,
      loops: observable,
      loading: observable,
      playingLoop: observable,
      count: observable,
      packId: observable,
      packConfig: observable,
      bpm: observable,
      mode: observable,
      instrument: observable,
      search: observable,
      autoPlayType: observable,
      editorOpen: observable,
      pageCount: computed,
      deletedLoops: computed,
      activeLoops: computed,
      reset: action,
      toPlaying: action,
      setLoopState: action,
      setPage: action,
      setPackConfig: action,
      removeLoop: action,
      setLoopsData: action,
      commitDeleted: action,
    })
  }

  get playing() {
    return this.playingLoop && this.playingLoop.playing
  }

  get empty() {
    return this.activeLoops.length === 0
  }

  get pageCount() {
    return Math.ceil(this.count / this.pageSize)
  }

  get deletedLoops() {
    return this.loops.filter(loop => loop.deleted)
  }

  get activeLoops() {
    return this.loops.filter(loop => !loop.deleted)
  }

  get isDefaultBpm() {
    return this.checkDefaultBpm({...this.bpm})
  }

  get bpmQueryParams() {
    if (this.isDefaultBpm) {
      return {}
    }
    return this.bpm
  }

  get modeQueryParams() {
    if (this.mode == 'all') {
      return {}
    }
    return {mode: this.mode}
  }

  get instrumentQueryParams() {
    if (this.instrument == 'all') {
      return {}
    }
    return {instrument: this.instrument}
  }

  get searchQueryParams() {
    if (this.search.length == 0) {
      return {}
    }
    return {search: this.search}
  }

  get queryParams() {
    return {
      page: this.page, 
      pageSize: this.pageSize, 
      ...this.bpmQueryParams, 
      ...this.modeQueryParams,
      ...this.instrumentQueryParams,
      ...this.searchQueryParams
    }
  }

  get isDefaulParams() {
    return Object.keys(this.queryParams).length == 2
  }

  get isEditorOpened() {
    return this.editorOpen || this.loops.some(l => l.open)
  }

  setEditorOpen = (open) => {
    this.editorOpen = open;
  }

  checkDefaultBpm = ({minBpm, maxBpm, doubled}) => {
    return doubled == 1 && minBpm == 40 && maxBpm == 200
  }

  reset = () => {
    this.commitDeleted()
    this.playingLoop = null
    //this.count = 0
    this.page = 1
  }

  toPlaying = (loopModel) => {
    this.playingLoop = loopModel
    this.loops.forEach(m => m.onPlaying())
    this.playingLoop.toView()
  }

  setLoopState = (state) => {
    if (this.loopState == state) {
      return;
    }
    this.reset()
    this.loopState = state
    this.load()
  }

  setPage = (page) => {
    this.reset()
    this.page = page
    this.load()
  }

  setPackConfig = (packConfig) => {
    this.packConfig = packConfig
  }

  removeLoop = (loop) => {
    this.loops.remove(loop)
    loop.parent = null
    // 目前只在最终删除时处理
    this.count = this.count - 1
  }

  commitDeleted = () => {
    this.loops.forEach(loop => loop.deleteMyLoop())
  }

  setLoopsData = (loopsData) => {
    //console.log('setLoopsData', loopsData)
    if (!loopsData) {
      return;
    }
    this.count = loopsData.count
    this.loops = loopsData.data.map(data => new LoopRowModel({parent: this, loop: data}))
    this.triggerAutoPlay()
  }

  triggerAutoPlay = () => {
    if (this.loops && this.loops.length > 0) {
      if (this.autoPlayType == 'first') {
        this.loops[0].setAutoPlay(true)
      }
      if (this.autoPlayType == 'last') {
        this.loops[this.loops.length - 1].setAutoPlay(true)
      }
    }
    this.autoPlayType = ''
  }

  setAutoPlay = (type) => {
    this.autoPlayType = type
  }

  setBpm = (bpm) => {
    this.bpm = bpm
    this.load()
  }

  setMode = (mode) => {
    if (this.mode == mode) {
      return;
    }
    this.mode = mode
    this.load()
  }

  setInstrument = (instrument) => {
    if (this.instrument == instrument) {
      return;
    }
    this.instrument = instrument
    this.load()
  }

  setSearch = (search) => {
    if (this.search == search) {
      return;
    }
    this.search = search
    this.load()
  }
}

export { LoopRowModel, AbsLoopsModel }